<template>
        <span
        class="text-danger">
        <i
            class="fa fa-times-circle fa-lg icon-button mr-1"
            title="Reprovar Pertinência"
            @click.stop="confirmarReprovar()"
        ></i>
        </span>
</template>

<script>

export default {
    props: {
        pleito: {
            type: Object
        },

        servicos: {
            type: Object
        },
    },

    methods: {
        confirmarReprovar() {
            this.$swal({
                title: 'Reprovar Pertinência do Pleito',
                html: `Confirma a <strong>REPROVAÇÃO DA PERTINÊNCIA</strong> do pleito <b>${this.pleito.descritivo}</b>?`,
                icon: 'error',
                showCancelButton: true,
                confirmButtonColor: '#3085d6',
                cancelButtonColor: '#d33',
                confirmButtonText: 'Sim',
                cancelButtonText: 'Não',
                input: 'textarea',
                inputPlaceholder: `Informe a Justificativa`,
                inputValidator: (value) => {
                    if (!value) {
                        return `A justificativa é obrigatória'`
                    }
                }
            }).then(result => {
                if (result.value) {
                    this.reprovarPertinencia(result.value)
                }
            })
        },

        reprovarPertinencia(justificativa) {
            this.$store.dispatch('addRequest')
            this.servicos.reprovarPertinencia(this.pleito.pleitoId, justificativa).then(response => {
                if (response) {
                    if (response.success) {
                        this.$toast.success(
                            'Pertinência do pleito reprovada com sucesso!',
                            'OK',
                            this.$toastConfig.success
                        )
                        this.$emit('listarPleitos')
                    } else {
                        this.$toast.error(
                            response.errors[0],
                            'ERROR',
                            this.$toastConfig.error
                        )
                    }
                }
                this.$store.dispatch('removeRequest')
            })
        }
    },
}

</script>